import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Box } from 'shared/ui'
import { AgentActionsList } from 'widgets/AgentActions'
import { SUCCESS_ACTIONS_CONFIG, SUCCESS_ACTION_ITEMS } from '../SuccessActions/config'
import type { FallbackAgentActionsStore } from './store/fallbackAgentActionsStore'

type IFallbackAgentActionsProps = {
  store: FallbackAgentActionsStore
}

export const FallbackAgentActions = observer(({ store }: IFallbackAgentActionsProps) => {
  useEffect(() => {
    if (store.control.list.length > 0) store.resetSectionError()
  }, [store.control.list.length])

  return (
    <Box marginTop={'32px'}>
      <AgentActionsList
        control={store.control}
        errors={store.errors}
        actionItems={SUCCESS_ACTION_ITEMS}
        actionsConfig={SUCCESS_ACTIONS_CONFIG}
        addButtonText='Add action (optional)'
      />
    </Box>
  )
})
